export const OVERVIEW_FLOW_MAX_COUNT = 10;
export const DEFAULT_FLOW_COUNT = 4;
